import React from 'react';

export default function Spacing( props ) {

	return (
		<div data-spacing={ props.spacing.space }>
		</div>
	);

}